/**
 *
 * @description 上报 资讯内容互动
 */
export const reportInfoContentInteraction = (params: {
    /** 资讯id */
    news_id: string

    /** 资讯标题 */
    news_title: string

    /** 发布人id(资讯发布者) */
    anthor_id: string

    /** 发布人名称(资讯发布者) */
    anthor_name: string

    /** 发布时间, 毫秒(资讯) */
    public_time: number

    /** 互动类型 */
    interactivity_type: '点赞' | '发帖' | '转发'
}) => {
    window['sensors'].track('InfoContentInteraction', params)
}

/**
 *
 * @description 上报 资讯帖子曝光
 */
export const reportInfoPostExposure = (params: {
    /** 资讯id */
    news_id: string

    /** 资讯标题 */
    news_title: string

    /** 帖子id */
    content_id: string

    /** 发布时间, 毫秒 */
    public_time: number
}) => {
    window['sensors'].track('InfoPostExposure', params)
}

/**
 *
 * @description 上报 资讯帖子 点击
 */
export const reportInfoPostClick = (params: {
    /** 资讯id */
    news_id: string

    /** 资讯标题 */
    news_title: string

    /** 帖子id */
    content_id: string

    /** 发布人id(资讯发布者) */
    anthor_id: string

    /** 发布人名称(资讯发布者) */
    anthor_name: string

    /** 发布时间, 毫秒 */
    public_time: number
}) => {
    window['sensors'].track('InfoPostClick', params)
}

/**
 *
 * @description 资讯帖子浏览
 */
export const reportInfoPostView = (params: {
    /** 资讯id */
    news_id: string

    /** 资讯标题 */
    news_title: string

    /** 帖子id */
    content_id: string

    /** 发布人id(资讯发布者) */
    anthor_id: string

    /** 发布人名称(资讯发布者) */
    anthor_name: string

    /** 发布时间, 毫秒 */
    public_time: number
}) => {
    window['sensors'].track('InfoPostView', params)
}

/**
 *
 * @description 资讯帖子互动
 */
export const reportInfoPostInteraction = (params: {
    /** 资讯id */
    news_id: string

    /** 资讯标题 */
    news_title: string

    /** 帖子id */
    content_id: string

    /** 发布人id(资讯发布者) */
    anthor_id: string

    /** 发布人名称(资讯发布者) */
    anthor_name: string

    /** 发布时间, 毫秒 */
    public_time: number

    /** 互动类型 */
    interactivity_type: '点赞' | '评论' | '转发'
}) => {
    window['sensors'].track('InfoPostInteraction', params)
}
